import store from '../app/ReduxStore';
import reducer from '../app/Reducers';
import moment from 'moment';
import Webservice from "../app/Webservice";
import isEmpty from 'lodash/isEmpty';


export function dispatchUpdateData(payload) {
	store.dispatch({
		type: reducer.ACTION_TYPES.UPDATE_DATA,
		payload: payload
	});
}

export const DATE_FORMAT = 'MM/DD/YYYY';
export function dateString(datestring) {
	return datestring ? moment(datestring).format(DATE_FORMAT) : undefined;
}


export const ssnString = ssn => `${ssn || ''}`.replace(/(\d{3}).*(\d{2}).*(\d{4})/, '$1-$2-$3');

export const MENU_PATHS = {
	LOGIN: '/',
	LOGOUT: '/logout',
    VETERANCONFIRMATIONPAGE:'/veteranconfirmation',
};
export const Approval_Status ={
	Pending_Approval_Supervisor:'Pending for approval',
	Fully_Approved:'Approved',
	Pending_Remove_ITSecurity:'Pending for removal by IT',
	

} 

export function getLoggedInUserID(){
	return  parseInt(sessionStorage.getItem('userID'))
}


export function isAuthenticated() {
	if (!isEmpty(sessionStorage.getItem('userToken'))) {
		return true;
	} else return false;
}






